"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const SellerPageQuery = (0, graphql_tag_1.default)(`
    query SellerPage(
        $sellerPageId: String!
    ) {
        sellerPage(id: $sellerPageId) {
            logoUrl
            style {
                backgroundColor
                colorPrimary
                colorSecondary
            }
            header {
                coverImage {
                    desktop
                    mobile
                }
            }
            primaryBanner {
                category {
                    id
                    title
                    label
                    description
                }
                subCategory {
                    id
                    title
                    label
                    description
                }
                brand {
                    label
                    slug
                }
                images {
                    desktop
                    mobile
                }
            }
            secondaryBanner {
                category {
                    id
                    title
                    label
                    description
                }
                subCategory {
                    id
                    title
                    label
                    description
                }
                brand {
                    label
                    slug
                }
                images {
                    desktop
                    mobile
                }
            }
            productSlide {
                type
                title
                settings {
                    category {
                        id
                        title
                        label
                        description
                    }
                    subCategory {
                        id
                        title
                        label
                        description
                    }
                    brand {
                        label
                        slug
                    }
                }
            }
            productGrid {
                type
                title
                settings {
                    category {
                        id
                        title
                        label
                        description
                    }
                    subCategory {
                        id
                        title
                        label
                        description
                    }
                    brand {
                        label
                        slug
                    }
                }
            }
            legalName
            stats {
                totalSales
            }
        }
    }
`);
exports.default = SellerPageQuery;
